import reportService from '../../services/api/Reports';
import {  CALLLOG_LOAD_ACTION, DIDS_LOAD_ACTION, AFFILIATESUMMARY_LOAD_ACTION, AFFILIATELOG_LOAD_ACTION,
  CALLLOG_REPORT_PRODUCT_TYPE_ACTION, CALLLOG_REPORT_ACCOUNTS_AND_COMPANIES_ACTION, 
  CALLLOG_REPORT_DOWNLOAD_CALL_RECORDING_ACTION } from '../action-types';
import {CALLLOG_LOAD_MUTATION, DIDS_LOAD_MUTATION, CALLLOG_REPORT_PRODUCT_TYPE_MUTATION,
  CALLLOG_REPORT_ACCOUNTS_AND_COMPANIES_MUTATION} from '../mutation-types';

import commonFunctions from '../../mixin/common-function-mixins';
import appConstants from '../../utility/app-constants';
// initial state
export const namespaced = true;

// initial state
export const state = {
  namespaced: true,
  state: {
    callLogData: [],
    didsData: [],
    susbscriptionsData: [],
    productTypes: []
  },
  payableData: [{PayableName : 'Yes', PayableValue : 1}, {PayableName : 'No', PayableValue : 0}, {PayableName : 'N/A', PayableValue : 'N/A'}],
  billableData: [{billableName : 'Yes', billableValue : 'Y'},{billableName : 'No', billableValue : 'N'}],
  accountsAndCompaniesData:[]
};


// actions
export const actions = {
  async [CALLLOG_LOAD_ACTION]({ commit }, request) {
    const response = await reportService.getCallLog(request);
    commit(CALLLOG_LOAD_MUTATION, response.data);
    return response;
  },
  async [DIDS_LOAD_ACTION]({ commit }) {
    const response = await reportService.getDIDs();
    commit(DIDS_LOAD_MUTATION, response.data);
    return response;
  },
  async [AFFILIATESUMMARY_LOAD_ACTION](state, url) {
    const response = await reportService.getAffiliateSummary(url);
    return response;
  },
  async [AFFILIATELOG_LOAD_ACTION](state, url) {
    const response = await reportService.getAffiliateCostLog(url);  
    if(response && response.data && response.data.items) { 
      response.data.items.map((r) => {
        var matchingValue = appConstants.callDispositionDisplayName.find((row) => 
        r.dispositionName && r.dispositionName.toLowerCase().replaceAll(" ", "").startsWith(row.key.toLowerCase()));
        if(matchingValue){
          r.dispositionName = matchingValue.value;
        }
      })  
    }
    return response;
  },
  async [CALLLOG_REPORT_PRODUCT_TYPE_ACTION]({commit})  {
    const response = await reportService.getProductTypes();
    commit(CALLLOG_REPORT_PRODUCT_TYPE_MUTATION, response.data);
    return response;
  },
  async [CALLLOG_REPORT_ACCOUNTS_AND_COMPANIES_ACTION]({commit})  {
    const response = await reportService.getAccountsAndCompanies();
    commit(CALLLOG_REPORT_ACCOUNTS_AND_COMPANIES_MUTATION, response.data);
    return response;
  },
  async [CALLLOG_REPORT_DOWNLOAD_CALL_RECORDING_ACTION](state, callSID)  {
    const response = await reportService.downloadCallRecordingFromBlob(callSID);
    return response.data;
  }
}

// mutations
export const mutations = {
  CALLLOG_LOAD_MUTATION(state, callLogData) {
    callLogData.map((r) => { 
      r.date = commonFunctions.methods.formatUTCDate(r.date.toString(), 'YYYY-MM-DD HH:mm'); 
      r.product = (r.product) ? r.product : 'Unknown'; 
      r.billableStatus = r.billableStatus == 'Y' ? 1 : 0;
      r.marketingSessionID = r.marketingSessionID ? r.marketingSessionID : '-';
      r.accountType = r.accountType ? r.accountType : '-';
      r.companyName = r.companyName ? r.companyName : '-';
      r.accountName = r.accountName ? r.accountName : '-';
      r.subscriptionName = r.subscriptionName ? r.subscriptionName : '-';
      r.totalCallDuration = (r.ivrTime.toString().includes(".")) ? parseInt(r.ivrTime.toString().split('.')[0])*60 + parseInt(r.ivrTime.toFixed(2).split('.')[1]) : r.ivrTime *60;
      r.tazIvrTime = (r.totalCallDuration ? parseInt(r.totalCallDuration) : r.totalCallDuration) - (r.thirdPartyTalkTime ? parseInt(r.thirdPartyTalkTime) : r.thirdPartyTalkTime);
      r.cost = r.cost ? r.cost.toFixed(2) : Number.isInteger(r.cost) ? r.cost : '-';
      r.revenue = r.revenue ? r.revenue.toFixed(2) : Number.isInteger(r.revenue) ? r.revenue : '-';
      r.dispositionName = r.dispositionName ? r.dispositionName : '-';
    });
    state.callLogData = callLogData;
  },
  SUBSCRIPTIONS_LOAD_MUTATION(state, newValue) {
    state.susbscriptionsData = newValue;
  },
  DIDS_LOAD_MUTATION(state, newValue) {
    state.didsData = newValue;
  },
  [CALLLOG_REPORT_PRODUCT_TYPE_MUTATION] (state, payLoad) {
    payLoad.push({ "leadTypeID": 0, "leadTypeName": "Unknown" });
    state.productTypes = commonFunctions.methods.sortRecords( payLoad, 'leadTypeName', true );
  },
  [CALLLOG_REPORT_ACCOUNTS_AND_COMPANIES_MUTATION](state, value) {
    state.accountsAndCompaniesData = value;
  },
}
